var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondenast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "",
    viewBox: "0 0 187.688 28.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "97.3 3.4 96.9 2.2 97.3 0.1 97.1 0 91.6 4.6 91.6 4.7 97.3 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2,37.2a5.3,5.3,0,0,1-3.8,1.6c-4.4,0-5.5-3.9-5.5-8.5s1-8.5,5.4-8.5a4.6,4.6,0,0,1,3.6,1.6l2.5,3.8h0.2V21.5H36.4l-2.3,1.2a5.9,5.9,0,0,0-3.8-1.4c-4.3,0-9.4,3.3-9.4,9.1s5,9.1,9.5,9.1a6.2,6.2,0,0,0,4-1.5l2.2,1.3h0.2v-6H36.6Z",
    transform: "translate(-20.9 -12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6,21.2c-4.2,0-9.2,3.6-9.2,9.1s5,9.1,9.2,9.1,9.2-3.6,9.2-9.1S54.9,21.2,50.6,21.2Zm0,17.6c-4.2,0-5.3-3.7-5.3-8.5s1.1-8.5,5.3-8.5,5.3,3.7,5.3,8.5S54.9,38.8,50.6,38.8Z",
    transform: "translate(-20.9 -12)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.8 10 57 10 57 21 56.9 21 49.1 9.5 42.1 9.5 42.1 10 44.2 10 44.2 26.6 42.1 26.6 42.1 27.1 47.1 27.1 47.1 26.6 44.9 26.6 44.9 10 44.9 10 57.5 27.4 57.7 27.4 57.7 10 59.8 10 59.8 9.5 54.8 9.5 54.8 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,21.5H84.5V22h2.3V38.6H84.5v0.5h7.9c3.9,0,10.4-1.7,10.4-8.9S96.3,21.5,92.4,21.5ZM92.2,38.6H90.3V22h1.9c4.6,0,6.7,3.3,6.7,8.3S96.8,38.6,92.2,38.6Z",
    transform: "translate(-20.9 -12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5,38.6h-6.6V29.9h3.3a13,13,0,0,1,2.3,3.4h0.2V26h-0.2a13,13,0,0,1-2.3,3.4h-3.3V22h5.9c1.7,1.1,3.2,4.2,3.2,4.2h0.2V21.5H106.1V22h2.3V38.6h-2.3v0.5h15.6V33.2h-0.2A20.6,20.6,0,0,1,118.5,38.6Z",
    transform: "translate(-20.9 -12)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.6 10 126.8 10 126.8 21 126.7 21 118.9 9.5 111.8 9.5 111.8 10 114 10 114 26.6 111.8 26.6 111.8 27.1 116.8 27.1 116.8 26.6 114.7 26.6 114.7 10 114.7 10 127.3 27.4 127.4 27.4 127.4 10 129.6 10 129.6 9.5 124.6 9.5 124.6 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.8,20.9h-0.2l-7.5,17.6H152V39h4.7V38.5h-2l2.7-6.3h5.7l2.9,6.3h-2.3V39h8.2V38.5h-2.1Zm-4.1,10.9,2.6-6.1,2.7,6.1h-5.3Z",
    transform: "translate(-20.9 -12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.3,28.8l-3.5-1.2c-1.7-.6-3.1-1.4-3.1-3.1s1.5-2.8,3.8-2.8a3.8,3.8,0,0,1,3.1,1.2l2.5,3.8h0.2V21.1h-0.2l-2.3,1.2a4.9,4.9,0,0,0-3.3-1.2,5.3,5.3,0,0,0-5.6,5.2c0,2.5,1.8,3.8,3.7,4.5l3.5,1.3c1.9,0.7,3.1,1.5,3.1,3.3s-1.2,3.3-4.2,3.3a7,7,0,0,1-4-1.5l-2.6-4.3h-0.3V39h0.3l2.2-1.2a7.4,7.4,0,0,0,4.2,1.5c3.8,0,6.3-2.7,6.3-5.7S186.5,29.5,184.3,28.8Z",
    transform: "translate(-20.9 -12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.2,21.5V27h0.2a28,28,0,0,1,3.1-5h3.1V38.6h-2.8v0.5h9.1V38.6h-2.8V22h3.1a28,28,0,0,1,3.1,5h0.2V21.6H192.2Z",
    transform: "translate(-20.9 -12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondenast);
export default __webpack_public_path__ + "static/media/condenast.d9e4736600d52ea1525cc820b37db5f5.svg";
export { ForwardRef as ReactComponent };